import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

/**
 * Compact shuttlecock icon for badminton activities and navigation actions.
 *
 * This intentionally uses a single inherited color and a simple silhouette so
 * badminton actions remain recognizable at 16–32px. Product branding uses
 * the full-detail `BrandMark` from `@bw/shared/components`.
 */
export function BadmintonMarkIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <g data-bw-mark="compact-shuttlecock">
        <path
          d="M7.15 4.05 4.1 12.8a1.45 1.45 0 0 0 1.37 1.93h13.06a1.45 1.45 0 0 0 1.37-1.93l-3.05-8.75"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.65"
        />
        <path
          d="m10 4.05-1.45 10.5M12 3.15v11.4m2-10.5 1.45 10.5"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.65"
        />
        <path
          d="M6.15 16.15h11.7c.75 0 1.35.6 1.35 1.35v.65c0 .75-.6 1.35-1.35 1.35H6.15c-.75 0-1.35-.6-1.35-1.35v-.65c0-.75.6-1.35 1.35-1.35Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
}
